import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { motion } from "framer-motion";
import { Gift, ArrowRight, Sparkles } from "lucide-react";

export const MemberBanner = () => {
  const { customer } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  if (!customer) return null;
  const firstName = customer.name?.split(" ")[0] || "";

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid="member-banner"
      className="rounded-2xl bg-[#2B2B2B] text-[#FDFBF7] p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-6"
    >
      <div className="flex items-center gap-4 flex-1">
        <span className="w-12 h-12 rounded-full bg-[#E63946] flex items-center justify-center shrink-0">
          <Gift className="w-6 h-6 text-white" />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-mono text-[#F4A261]">{t("mbn.title")}</p>
          <p className="mt-0.5 text-lg font-display font-bold">
            {t("mbn.greeting")}{firstName ? ` ${firstName}` : ""} — {t("mbn.walletLabel")}
          </p>
          <p className="text-sm text-[#FDFBF7]/70">{t("mbn.comingSoon")}</p>
        </div>
      </div>

      {/* Virtual member card + CTA (cashback not active yet) */}
      <div className="flex items-center gap-5">
        <div className="hidden sm:flex flex-col items-end text-right">
          <span data-testid="member-card-badge" className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 text-xs font-mono">
            <Sparkles className="w-3.5 h-3.5 text-[#F4A261]" /> {t("mbn.perk")}
          </span>
        </div>
        <button
          data-testid="member-banner-cta"
          onClick={() => navigate("/membre")}
          className="flex items-center gap-2 px-6 py-3 rounded-full bg-[#E63946] text-white font-bold text-sm hover:scale-[1.03] transition-transform shrink-0"
        >
          {t("mbn.cta")} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
};
